// Reset dropdown state before turbolinks caches the page
document.addEventListener('turbolinks:before-cache', () => {
  $('.custom-navbar .dropdown-menu').removeAttr('style').removeClass('show');
  $('.custom-navbar .expanded').removeClass('expanded');
});

// From Tiffany: "Can the dropdown appear when the mouse hovers over the links?"
document.addEventListener('turbolinks:load', () => {
  // eslint-disable-next-line func-names
  $('ul.navbar-nav li.dropdown').hover(function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(100)
      .fadeIn(200);
    // eslint-disable-next-line func-names
  }, function () {
    $(this).find('.dropdown-menu').stop(true, true).delay(100)
      .fadeOut(200);
  });

  $('.dropdown-menu a.dropdown-toggle').on('click', function menu() {
    const $subMenu = $(this).next('.dropdown-menu');
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show')
        .removeClass('show');
      $(this).parents('.dropdown-menu').first().find('.expanded')
        .removeClass('expanded');
    }
    $subMenu.toggleClass('show');
    $(this).toggleClass('expanded');

    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', () => {
      $('.dropdown-submenu .show').removeClass('show');
      $('.dropdown-submenu .expanded').removeClass('expanded');
    });

    return false;
  });
});
